import { api } from "@/lib/api";

const KEY = "vs_campaign";
const WINDOW_DAYS = 30;

/** Remembers which WhatsApp update brought this visitor, so their order can be credited to it. */
export function captureCampaign() {
  try {
    const params = new URLSearchParams(window.location.search);
    const id = (params.get("c") || "").replace(/[^a-f0-9]/gi, "").slice(0, 24);
    if (!id) return;
    localStorage.setItem(KEY, JSON.stringify({ id, at: Date.now() }));
    params.delete("c");
    const query = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (query ? `?${query}` : ""));
    if (!sessionStorage.getItem(`${KEY}_${id}`)) {
      sessionStorage.setItem(`${KEY}_${id}`, "1");
      api.post(`/campaigns/${id}/visit`).catch(() => {});
    }
  } catch {
    /* private mode or blocked storage — tracking is optional */
  }
}

export function currentCampaignId() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!saved?.id) return "";
    if (Date.now() - saved.at > WINDOW_DAYS * 24 * 60 * 60 * 1000) return "";
    return saved.id;
  } catch {
    return "";
  }
}
